import { memo } from 'react';
import { Box, Paper, type PaperProps, styled } from '@lingoda/ui';
import type { ClassId } from '@lingoda/classes';
import { RouterLink } from '@lingoda/router';
import type { CommonProps } from '../../types/props';

interface Props extends Pick<CommonProps, 'linkTo' | 'openInNewTab'> {
    classes?: { root: string };
    children?: React.ReactNode;
    classId?: ClassId;
    ribbon?: string;
    onMouseEnter?: React.MouseEventHandler;
    onMouseLeave?: React.MouseEventHandler;
}

const PaperStyled = styled(Paper)<PaperProps & { component?: React.ElementType }>(({ theme }) => ({
    overflow: 'hidden',
    height: '100%',
    width: '100%',
    minHeight: 255,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.common.white,
    textDecoration: 'inherit',
    border: `1px solid ${theme.palette.divider}`,

    '&:hover': {
        backgroundColor: theme.colors.background['default-hover'],
        borderColor: theme.colors.border.strong,
        '& .MuiAvatar-circular': {
            borderColor: theme.colors.background['default-hover'],
        },
    },
}));

const ClassTileComponent = ({
    onMouseEnter,
    onMouseLeave,
    children,
    linkTo,
    openInNewTab,
}: Props) => {
    return (
        <>
            <PaperStyled
                tabIndex={0}
                variant="outlined"
                component="section"
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                {...(linkTo && {
                    component: RouterLink,
                    to: linkTo,
                    target: openInNewTab ? '_blank' : '_self',
                })}
                data-cy="class-item class-tile"
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>{children}</Box>
            </PaperStyled>
        </>
    );
};

export const ClassTile = memo(ClassTileComponent);
